// extracted by css-extract-rspack-plugin
export default {"plugin-menu-root":"M80a79","pluginMenuRoot":"M80a79"};